angular.module('ApptBookApp').service('appointmentBookHelperService', [
    '$compile',
    '$rootScope',
    'appointmentBookGlobalsService',
    'meevo.components.common.IdentityService',
    '$mdSidenav',
    '$translate',
    'appointmentBookModalService',
    '$timeout',
    'restServer',
    '$q',
    'meevo.AppSettings',
    'meevo.components.common.BusinessInfoDataService',
(
    $compile,
    $rootScope,
    globals,
    identityService,
    $mdSidenav,
    $translate,
    modal,
    $timeout,
    restServer,
    $q,
    appSettings: Meevo.Components.Common.IAppSettings,
    businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService
) => {
    let counts;

    let isChromeVersionIssue;

    function getChromeVersionIssue() {

        if (isChromeVersionIssue == undefined) {

            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

            isChromeVersionIssue = raw && (parseInt(raw[2], 10) == 48 || parseInt(raw[2], 10) == 49) ;

        }
        return isChromeVersionIssue;
    }


        function shrinkNonGapSteps(nonGapSteps, clientNameHeight)
        {
            function shrinkNonGapStep(containerToShrink, contentHeight, nonGapStepAvailableHeight)
            {
                if (contentHeight > nonGapStepAvailableHeight) {
                    containerToShrink.css({
                        'transform': `scaleY(${nonGapStepAvailableHeight / contentHeight})`,
                        'transform-origin': 'top',
                    });
                }
            }

            nonGapSteps.forEach(nonGapStep => {
                let contentHeight = nonGapStep.find('.content').height();
                // there's content so shrink if necessary
                if (contentHeight > 0) {
                    shrinkNonGapStep(nonGapStep.find('.content'), contentHeight, nonGapStep.height() - clientNameHeight);
                }
                // there's just the client name so shrink if necessary
                else if (clientNameHeight > 0) {
                    shrinkNonGapStep(nonGapStep.find('.clientName'), clientNameHeight, nonGapStep.height());
                }
            });
        }


        var service = {
            lastScheduleIds: [],
            repositionTimer: null,
            membershipTypeRibbon: null,


        isEditorOpen(displayMessage: boolean = false) {
            const isOpen = $mdSidenav('right').isOpen() || $mdSidenav('blockEditor').isOpen();
            if (isOpen && displayMessage) {
                modal.showMessage($translate.instant('MESSAGE_APPOINTMENT_EDITOR_OPEN'));
            }
            return isOpen;
        },
        setAppointmentBookIncrement() {
            switch (globals.businessInfo.appointmentBookIncrement) {
                case Meevo.Model.AppointmentIncrementEnum.Min5:
                    $rootScope.appointmentBookIncrement = 5;
                    break;
                case Meevo.Model.AppointmentIncrementEnum.Min10:
                    $rootScope.appointmentBookIncrement = 10;
                    break;
                case Meevo.Model.AppointmentIncrementEnum.Min15:
                    $rootScope.appointmentBookIncrement = 15;
                    break;
            }
        },
        convertAppointmentBookIncrementToNumber(increment: Meevo.Model.AppointmentIncrementEnum): number {
            return (businessInfoDataService.getAppointmentBookIncrementInMinutes(increment));
        },
        GetColumnId(startDate, employeeId) {
            return replaceAll(startDate, '/', '-') + '_' + employeeId.replaceAll('-', '');
        },
        getEntityId(entity) {
            return entity.employeeId || entity.resourceUnitId;
        },
        getOffsetMinutes(actualStartDateTime): number {
            // round down to nearest 5 minute interval
            const startMinutes = actualStartDateTime.minutes();
            const minutes = startMinutes - (startMinutes % 5);
            return minutes % $rootScope.appointmentBookIncrement;
        },
        getOffset: function(actualStartDateTime): any {
            return service.convertMinutesToPixels(service.getOffsetMinutes(actualStartDateTime));
        },
        // Whenever getting coordinates for a cell, those coordinates are relative to the divRows and divCells containers so they don't include the offset for the time column or header
        GetCellByIds: function(date, time, employeeId): any {
            const columnId = this.GetColumnId(date, employeeId);

                const cell: any = {};

                const divColumns = $('.column');
                for (let j = 0; j < divColumns.length; j++) {
                    const column = $(divColumns[j]);
                    if (column.attr('id') == columnId) {
                        cell.left = column.position().left;
                        break;
                    }
                }

                const divRows = $('.row');
                for (let i = 0; i < divRows.length; i++) {
                    const row = $(divRows[i]);
                    if (row.attr('id') == time) {
                        cell.top = row.position().top;
                        break;
                    }
                }

                if (cell.left == undefined || cell.top == undefined) {
                    return null;
                } else {
                    return cell;
                }
            },
            // Whenever getting coordinates for a cell, those coordinates are relative to the divRows and divCells containers so they don't include the offset for the time column or header
            GetCellByCoordinates: (
                x: number,
                y: number,
                considerOffsets: boolean,
                verticalOffset: number = 0,
                horizontalOffset: number = 0
            ): any => {
                if (considerOffsets) {
                    y = y - verticalOffset;
                    x = x - globals.timeColumnWidth + horizontalOffset;
                }

                let cell;

                const divColumns = $('#divColumns .column');
                for (let columnIndex = 0; columnIndex < divColumns.length; columnIndex++) {
                    const column = $(divColumns[columnIndex]);
                    const left = column.position().left;
                    if (x >= left && x <= left + column.width()) {
                        cell = {
                            left: left,
                            columnId: column.attr('id'),
                            employeeId: column.data('employeeId'),
                            resourceId: column.data('resourceId'),
                        };
                        const split = cell.columnId.split('_');
                        cell.date = split[0];
                        cell.entityId = split[1];
                        break;
                    }
                }

                if (!cell) {
                    return null;
                }

                const divRows = $('#divRows .row');
                for (let rowIndex = 0; rowIndex < divRows.length; rowIndex++) {
                    const row = $(divRows[rowIndex]);
                    const top = row.position().top;
                    if (y >= top && y <= top + row.height()) {
                        cell.top = top;
                        cell.time = row.attr('id').replace('-', ':');
                        cell.startMinutes = row.data('min');
                        break;
                    }
                }

                if (cell.left == undefined || cell.top == undefined) {
                    return null;
                }

                return cell;
            },
            GetDiv(data) {
                return `<div ${data.id ? `id="${data.id}"` : ''} ${data.data || ''} ${data.className ? `class="${data.className}"` : ''} ${data.style ? `style="${data.style}"` : ''}>${data.content || ''}</div>`;
            },
            WriteDiv(data) {
                //console.time('  writeDiv');
                const html = this.GetDiv(data);
                if (html.length > 0) {
                    $(data.container || '#divAppointmentBookContainer').append(html);
                }
                //console.timeEnd('  writeDiv');
            },
            WireUpClientTypeClicking(id, clientTypeColor, clientTypeId, clientTypeDisplayName) {
                if (!clientTypeId || !clientTypeColor) {
                    return;
                }

                let container = $(`#clientTypeContainer_${id}`);
                const template = `<meevo-client-type client-type-color="${clientTypeColor}" use-toast="false" client-type-display-name="${clientTypeDisplayName}"></meevo-client-type>`;
                container.empty().append($compile(template)($rootScope));
            },
            showPopup(popupId) {
                $(popupId)
                    .css({ width: '100%', height: '100%', position: 'fixed' })
                    .show();
                globals.popupCount++;
            },
            hidePopup(popupId) {
                const popup = $(popupId);
                if (popup.is(':hidden')) {
                    return;
                }
                popup.hide();
                globals.popupCount--;

                if (globals.popupCount == 0) {
                    $('body')
                        .scrollTop(globals.scrollTop)
                        .scrollLeft(globals.scrollLeft);

                    globals.scrollTop = 0;
                    globals.scrollLeft = 0;
                }
            },
            showNewBooking(e, setTimeFunction?: any) {
                if (service.isEditorOpen()) {
                    return;
                }
                const cell = this.GetCellByCoordinates(
                    e.pageX,
                    e.pageY,
                    true,
                    globals.headerOffset + globals.containerOffset - globals.scrollContainer.scrollTop(),
                    globals.scrollContainer.scrollLeft()
                );
                globals.highlightedCell = cell;

                if (setTimeFunction && angular.isFunction(setTimeFunction)) {
                    setTimeFunction(cell);
                }

                const actualLeft = cell.left;
                const actualTop = cell.top;
                globals.divCellHighlight
                    .css('left', actualLeft)
                    .css('top', actualTop)
                    .show();

                const columnWidth: any = $(`#${cell.columnId}`).width();
                globals.divCellHighlight.css('width', columnWidth);

                this.positionPopup(globals.divNewBooking, globals.divCellHighlight);

                service.cleanupPositionHelpers();
            },
            CheckForDoubleBookWarning(isAppointment = true) {
                if (this.GetAppointmentsByCell(globals.highlightedCell).length > 0) {
                    return modal.showMessage($translate.instant('MESSAGE_DOUBLEBOOK_WARNING'), {
                        buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    });
                } else {
                    return $q.resolve(Meevo.Model.MessageBoxButtonResult.Yes);
                }
            },
            GetAppointmentsByCell(cell) {
                const cellTop = cell.top;

                const elements = $(`#${cell.columnId}`)
                    .find('.appointment, .block')
                    .not('.appointmentOverlay')

                const foundElements = _(elements).filter(elem => {
                    const $elem = $(elem);

                    if ($elem.hasClass('block')) {
                        const elemTop = $elem.position().top + globals.overlapTolerance;
                        const elemBottom = elemTop + $elem.outerHeight() - 1 - globals.overlapTolerance;
                        return (
                            cellTop >= elemTop &&
                            cellTop < elemBottom
                        );
                    }

                    const nongap = $elem.children('.nongap');

                    return !!_(nongap).find(element => {
                        const $element = $(element);
                        const elementParentTop = $element.parent().position().top;
                        const topOffset = elementParentTop + $element.position().top + globals.overlapTolerance;
                        const stepBottom = topOffset + $element.outerHeight() - 1 - globals.overlapTolerance;

                        return cellTop >= topOffset && cellTop < stepBottom;
                    });
                });

                return foundElements;
            },
            getBusinessTime() {
                // calculate business time by getting UTC time and adding the business time offset
                return moment.utc().add(moment.duration(globals.timeZoneOffset));
            },
            getBusinessDate(): Date {
                return moment(service.getBusinessTime().format('YYYY-MM-DD')).toDate();
            },
            isInPast(inputDateTime: Date): boolean {
                const inputStartOfDay = moment(moment(inputDateTime).format('YYYY-MM-DD')).toDate();
                const businessStartOfDay = service.getBusinessDate();
                return inputStartOfDay < businessStartOfDay;
            },
            isInFuture(inputDateTime: Date): boolean {
                const inputStartOfDay = moment(moment(inputDateTime).format('YYYY-MM-DD')).toDate();
                const businessStartOfTomorrow = moment(service.getBusinessTime().add(1, 'days').format('YYYY-MM-DD')).toDate();
                return inputStartOfDay >= businessStartOfTomorrow;
            },
            clickedCellInPast(clickedCell): boolean {
                if (!clickedCell) {
                    return false;
                }
                // Don't proceed if trying to book appointment in past
                const columnBooking = globals.columnBookings.find(booking => booking.columnId == clickedCell.columnId);
                return columnBooking.isInPast;
            },
            positionPopup(popupDiv, clickedDiv, open: boolean = true) {
                if (service.isEditorOpen() || !popupDiv) {
                    return;
                }

                const dialogDivHeight = popupDiv.height();
                const dialogDivWidth = popupDiv.width();

                // width of WTS cannot be retrieved until it's open, which happens after this logic passes, so need to use pre-calculated number
                // which is width of WTS in open state. (65 (button image width) + 2x12 (inline button padding) + 2x2.5 (button border) + 2x8 (selector padding))
                const workTicketSelectorWidth = 110;
                let scrollBarWidth = globals.scrollContainer.width() - globals.scrollContainer.get(0).clientWidth;

                var newLeft = clickedDiv.position().left + clickedDiv.width() + 10;
                var newTop = clickedDiv.position().top;

                if (newTop + dialogDivHeight > globals.bookContainer.height()) {
                    if (globals.bookContainer.height() - dialogDivHeight - 15 < 0) newTop = 0;
                    else newTop = globals.bookContainer.height() - dialogDivHeight - 15;
                }

                if (newLeft + dialogDivWidth + workTicketSelectorWidth + scrollBarWidth - globals.scrollContainer.scrollLeft() > globals.scrollContainer.width()) {
                    newLeft = clickedDiv.position().left - dialogDivWidth - 10;
                    if (newLeft < 0) {
                        newLeft = 0;
                    }
                }

                if (globals.isMobile) {
                    newTop =
                        newTop + dialogDivHeight + 40 > globals.bookContainer.height()
                            ? newTop - dialogDivHeight - 10
                            : newTop + 40;
                    newLeft = clickedDiv.position().left;
                }

                popupDiv.css('left', newLeft).css('top', newTop);
                if (open) {
                    popupDiv.show();
                }

                if (!globals.currentPopupHeightWatchFn) {
                    globals.currentPopupHeightWatchFn = $rootScope.$watch(
                        () =>
                            '' +
                            (globals.currentPopupDiv ? globals.currentPopupDiv.height() : '_') +
                            globals.displayPCNotes +
                            globals.displayClNotes +
                            globals.displayStatus,
                        service.repositionPopupTop
                    );
                }
            },
            repositionPopupTop() {
                if (service.isEditorOpen()) {
                    return;
                }

                if (service.repositionTimer == null) {
                    $timeout.cancel(service.repositionTimer);
                }
                service.repositionTimer = $timeout(() => {
                    if (globals.currentActiveBooking) {
                        let newTop = globals.currentActiveBooking.position().top;
                        let dialogDivHeight = globals.currentPopupDiv.height();
                        if (
                            globals.currentPopupDiv[0].getBoundingClientRect().height != dialogDivHeight &&
                            !globals.isMobile &&
                            dialogDivHeight != 0 &&
                            globals.currentPopupDiv[0].getBoundingClientRect().height != 0
                        ) {
                            dialogDivHeight = Math.ceil(globals.currentPopupDiv[0].getBoundingClientRect().height);
                            globals.currentPopupDiv.height(dialogDivHeight);
                        }

                        if (
                            newTop - $('#divAppointmentBookScrollContainer').scrollTop() + dialogDivHeight >
                            $('#divAppointmentBookScrollContainer').height()
                        ) {
                            if (
                                $('#divAppointmentBookScrollContainer').height() +
                                $('#divAppointmentBookScrollContainer').scrollTop() -
                                dialogDivHeight -
                                15 <
                                0
                            )
                                newTop = $('#divAppointmentBookScrollContainer').scrollTop();
                            else
                                newTop =
                                    $('#divAppointmentBookScrollContainer').height() +
                                    $('#divAppointmentBookScrollContainer').scrollTop() -
                                    dialogDivHeight -
                                    15;
                        }

                        globals.currentPopupDiv.css('top', newTop);
                    }
                }).finally(() => {
                    service.repositionTimer = null;
                });
            },
            destroyDraggable() {
                if (globals.currentlyDraggableElement) {
                    try {
                        if (globals.currentlyDraggableElement.draggable('instance')) {
                            globals.currentlyDraggableElement.draggable('destroy');
                        }
                    } finally {
                        globals.currentlyDraggableElement.css('z-index', globals.zIndexBooking);
                        globals.currentlyDraggableElement = undefined;
                    }
                }
            },
            destroyResizable() {
                if (globals.currentlyResizableElements) {
                    try {
                        if (globals.currentlyResizableElements.resizable('instance')) {
                            globals.currentlyResizableElements.resizable('destroy');
                        }
                    } finally {
                        globals.currentlyResizableElements.css('z-index', globals.zIndexBooking);
                        globals.currentlyResizableElements = undefined;
                    }
                }

                $('.appt-book-step-resize-helper, .appt-book-step-resize-handle, .appt-book-step-resize-structure').remove();
            },
            hideSmartAssistant() {
                if (!globals.divAppointmentDetails) {
                    globals.divAppointmentDetails = $('#divAppointmentDetails');
                }
                globals.divAppointmentDetails.hide();

                if (!globals.divBlockDetails) {
                    globals.divBlockDetails = $('#divBlockDetails');
                }
                globals.divBlockDetails.hide();

                if (!globals.divWorkTicketSelector) {
                    globals.divWorkTicketSelector = $('#divWorkTicketSelector');
                }
                globals.divWorkTicketSelector.hide();
                
                $('.appt-book-step-resize-handle, .appt-book-step-resize-structure').hide();
            },
            cleanupPositionHelpers() {
                globals.currentActiveBooking = undefined;
                if (globals.currentPopupHeightWatchFn) {
                    globals.currentPopupHeightWatchFn();
                }
                globals.currentPopupHeightWatchFn = undefined;
                globals.currentPopupDiv = undefined;
                globals.displayPCNotes = false;
                globals.displayClNotes = false;
                globals.displayStatus = false;
            },
            AdjustColumnCellsForMultiBooking(columnId, setIsExpand = false) {
                const sortedBookings = this.GetSortedBookings(columnId);

                const columnBooking: any = _.findWhere(globals.columnBookings, { columnId: columnId });
                columnBooking.isExpandable = false;

                // Created copy of sorted list so that can iterate over both at the same time below
                var sortedBookings2 = _.sortBy(sortedBookings, (booking: any) => booking.top);

                sortedBookings.forEach(mainBooking => {
                    this.GetCellSharingBookings(mainBooking, sortedBookings2);
                    mainBooking.booking.level = 0;

                    // ??? all these CSS resets are probably unnecessary ???
                    mainBooking.booking.css('left', 'auto');
                    mainBooking.booking
                        .find('.sideBackground')
                        .css('margin-left', '0px');
                    mainBooking.booking
                        .find('.gapSideBackground')
                        .first()
                        .css('display', 'block');
                    mainBooking.booking
                        .find('.nongap')
                        .css({ 'margin-left': globals.appointmentLeftBarWidth, 'width': 'auto'});
                });

                /********/
                const bookingSwimLanes = this.DistributeBookings(sortedBookings, !columnBooking.isExpanded);
                const segments = bookingSwimLanes.segments; // for current column;
                const columnPosition = $(`#${columnBooking.columnId}`).position();
                var columnLeft = columnPosition ? columnPosition.left : 0;
                columnBooking.maxDoubleBooked = _.max(segments, (swimLane: any) => {
                    return swimLane.length;
                }).length;
                /********/

                segments.forEach(segment => {
                    var swimLanes = segment;
                    var noOfSwimLane = swimLanes.length;
                    if (noOfSwimLane > 1) {
                        columnBooking.isExpandable = true;
                    }
                    var bookingWidth =
                        (columnBooking.isExpanded
                            ? globals.columnWidth * columnBooking.maxDoubleBooked
                            : globals.columnWidth) / noOfSwimLane;
                    $(`#${columnId}`).css('width', bookingWidth * noOfSwimLane);
                    var bookingFullWidth = bookingWidth;
                    var bookingLeft = columnLeft;
                    swimLanes.forEach((bookings, laneIndex) => {
                        const indentedBookings = new Array<boolean>(bookings.length);
                        if (!columnBooking.isExpanded) {
                            var steps = [];
                            bookings.forEach((booking, bookingIndex) => {
                                if (!booking.steps || booking.steps.length < 1) {
                                    const bookingStep = {
                                        bookingIndex: bookingIndex,
                                        height: booking.height,
                                        top: booking.top,
                                        serviceStepNumber: 1,
                                        serviceStepType: Meevo.Model.ServiceStepTypeEnum.Other
                                    }
                                    steps.push(bookingStep);
                                    return;
                                }
                                booking.steps.forEach(step => step.bookingIndex = bookingIndex);
                                steps = [...steps, ...booking.steps];
                            });

                            steps = steps.sort((a, b) => {
                                if (Math.abs(a.top - b.top) < 2) {
                                    if (this.isGapOrResourceStepInEmployeeView(a.serviceStepType)) {
                                        return this.isGapOrResourceStepInEmployeeView(b.serviceStepType) ?
                                            a.bookingIndex > b.bookingIndex ? 1 : -1 :
                                        1;
                                    } else {
                                        return -1;
                                    }
                                }
                                return a.top > b.top ? 1 : -1;
                            });

                            steps.forEach(step => {
                                if (indentedBookings[step.bookingIndex]) {
                                    return;
                                }
                                steps.forEach(otherStep => {
                                    if (step.bookingIndex === otherStep.bookingIndex) {
                                        return;
                                    }
                                    const stepBottom = step.top + step.height;
                                    const gapStepBottom = otherStep.top + otherStep.height;
                                    const isStepTopEqual = Math.abs(step.top - otherStep.top) < globals.overlapTolerance;
                                    const isStepBottomEqual = Math.abs(stepBottom - gapStepBottom) < globals.overlapTolerance;
                                    if (isStepTopEqual || isStepBottomEqual ||
                                        (Math.floor(stepBottom) > otherStep.top && Math.ceil(stepBottom) < gapStepBottom) ||
                                        (Math.floor(step.top) > otherStep.top && Math.ceil(step.top) < gapStepBottom)) {
                                            const isGapOtherStep = this.isGapOrResourceStepInEmployeeView(otherStep.serviceStepType);
                                            const isGapStep = this.isGapOrResourceStepInEmployeeView(step.serviceStepType);
                                            if (!indentedBookings[otherStep.bookingIndex] && !indentedBookings[step.bookingIndex] &&
                                                (!isGapStep || (isGapOtherStep &&
                                                    (Math.ceil(otherStep.top) < step.top || otherStep.bookingIndex < step.bookingIndex)))) {

                                                indentedBookings[step.bookingIndex] = true;
                                            }

                                            if ((isGapStep && indentedBookings[step.bookingIndex] && !isGapOtherStep) ||
                                                (!isGapStep && isGapOtherStep && indentedBookings[otherStep.bookingIndex])){

                                                    const childBooking = (isGapStep ?
                                                        bookings[step.bookingIndex] :
                                                        bookings[otherStep.bookingIndex]).booking;
                                                    const parentBooking = (isGapStep ?
                                                        bookings[otherStep.bookingIndex] :
                                                        bookings[step.bookingIndex]).booking;

                                                if (!$(childBooking).data('isChild')) {
                                                    $(childBooking).data('isChild', true);
                                                    $(childBooking.context).insertBefore(parentBooking);
                                                }
                                            }
                                        }
                                });
                            });
                            steps.forEach(step => delete(step.bookingIndex));
                        } else {
                            columnBooking.isExpandable = true;
                        }

                        for (let idx = 0; idx < bookings.length; idx++) {
                            bookingLeft = bookingFullWidth * laneIndex + columnLeft;
                            bookingWidth = bookingFullWidth;

                            if (indentedBookings[idx]) {
                                bookingLeft += globals.appointmentLeftBarWidth;
                                bookingWidth -= globals.appointmentLeftBarWidth;
                                columnBooking.isExpandable = true;
                            }

                            bookings[idx].booking.css({
                                'left': bookingLeft == 0 ? 'auto': bookingLeft,
                                'width': bookingWidth
                            });
                        }
                    });
                });

                const expandedColumn = service.FindExpandedHeaderColumn(`Header${columnBooking.columnId}`);
                if (expandedColumn.length > 0) {
                    expandedColumn[0].doubleBookedAppts = columnBooking.maxDoubleBooked;
                }

                if (columnBooking.isExpandable) {
                    $(`#Header${columnId} #btnExpandCollapse`).css('display', 'inline-flex');
                    $(`#Header${columnId} #btnExpandCollapse`).css('margin', 'auto 0');
                } else {
                    $(`#Header${columnId} #btnExpandCollapse`).css('display', 'none');
                }

                service.expandCollapseEmployeeColumn(`Header${columnId}`, setIsExpand);
            },
            getBookingHeight: booking => {
                return booking.data('height') ? booking.data('height') : booking.outerHeight();
            },
            AdjustColumnsForMultiBooking(relatedColumnIds, setIsExpand = false) {
                globals.columnBookings.forEach(columnBooking => {
                    if (relatedColumnIds.indexOf(columnBooking.columnId) >= 0) {
                        this.AdjustColumnCellsForMultiBooking(columnBooking.columnId, setIsExpand);
                    }
                });
            },

            DistributeBookings(bookings: Array<any>, allowGapBookingInSwimLanes = false) {
                var distributedBookings = {
                    segments: [],
                    isOverbookedOrGapBooked: false,
                };

                if (_.isEmpty(bookings)) {
                    return distributedBookings;
                }

                // separate bookings into segments
                // assume bookings are sorted by start time or in other words, by top
                // prime the segments with the first booking
                var segments = [[bookings[0]]];
                var maxBottom = bookings[0].top + bookings[0].height;

                _.forEach(bookings.slice(1), booking => {
                    var segment = _.last(segments);

                    // if booking overlaps with current segment, add the booking into it
                    if (booking.top < maxBottom - globals.overlapTolerance && booking.top >= segment[0].top) {
                        segment.push(booking);
                        maxBottom = _.max([maxBottom, booking.top + booking.height]);
                        return;
                    }

                    // booking does not overlap so start a new segment
                    segments.push([booking]);
                    maxBottom = booking.top + booking.height;
                });

                _.forEach(segments, segmentBookings => {
                    // build conflict arrays
                    var conflicts = new Array(segmentBookings.length);
                    var equivalents = new Array(segmentBookings.length);

                    _.forEach(segmentBookings, (booking, bookingIndex) => {
                        if (!conflicts[bookingIndex]) {
                            conflicts[bookingIndex] = [];
                        }

                        if (!equivalents[bookingIndex]) {
                            equivalents[bookingIndex] = [];
                        }

                        _.forEach(segmentBookings, (conflictBooking, conflictIndex) => {
                            if (conflictIndex <= bookingIndex) {
                                // already would have been considered
                                return;
                            }

                            if (booking.top + booking.height - globals.overlapTolerance <= conflictBooking.top) {
                                // completely non-overlapping
                                return;
                            }

                            var areBookingsEquivalent = false;
                            if (
                                Math.abs(booking.top - conflictBooking.top) <= globals.overlapTolerance &&
                                Math.abs(booking.height - conflictBooking.height) <= globals.overlapTolerance ) {
                                // potentially equivalent shape, unless steps tell a different story later
                                areBookingsEquivalent = true;
                            }

                            if (
                                allowGapBookingInSwimLanes &&
                                (booking.steps.length || conflictBooking.steps.length)) {
                                var stepsOrBlocks = [];
                                stepsOrBlocks.push(...(booking.steps.length ? booking.steps : [booking]));
                                stepsOrBlocks.push(...(conflictBooking.steps.length ? conflictBooking.steps : [conflictBooking]));

                                stepsOrBlocks = _.sortBy(stepsOrBlocks, step => step.top);
                                var nonGapBookableStepsOrBlocks = _.filter(
                                    stepsOrBlocks, 
                                    (step: any) => !service.isGapOrResourceStepInEmployeeView(step.serviceStepType));

                                if (
                                    _.all(nonGapBookableStepsOrBlocks, (step, stepIndex) => {
                                        return (
                                            stepIndex === 0 ||
                                            nonGapBookableStepsOrBlocks[stepIndex - 1].top +
                                            nonGapBookableStepsOrBlocks[stepIndex - 1].height -
                                            globals.overlapTolerance <=
                                            step.top
                                        );
                                    })
                                ) {
                                    // overlap is only during a gap step
                                    distributedBookings.isOverbookedOrGapBooked = true;
                                    return;
                                }

                                // verify step equivalence
                                if ( stepsOrBlocks.length != nonGapBookableStepsOrBlocks.length &&
                                    (!booking.steps.length || !conflictBooking.steps.length ||
                                    booking.steps.length != conflictBooking.steps.length ||
                                    _.any(stepsOrBlocks, (step, stepIndex) => {
                                        return stepIndex % 2 == 1 &&
                                        (Math.abs(step.top - stepsOrBlocks[stepIndex -1].top) > globals.overlapTolerance ||
                                        Math.abs(step.height - stepsOrBlocks[stepIndex -1].height) > globals.overlapTolerance ||
                                        service.isGapOrResourceStepInEmployeeView(step.serviceStepType) != 
                                            service.isGapOrResourceStepInEmployeeView(stepsOrBlocks[stepIndex -1].serviceStepType))
                                    }))) {
                                    // there are some steps that may be gap booked among the two bookings
                                    // AND either exactly one of booking and conflictBooking is a block
                                    // OR neither is a block, and steps are not of identical duration or gap bookability
                                    areBookingsEquivalent = false;
                                }
                            }

                            distributedBookings.isOverbookedOrGapBooked = true;

                            // booking is in conflict with conflictBooking, and vice versa
                            if (!conflicts[conflictIndex]) {
                                conflicts[conflictIndex] = [];
                            }

                            conflicts[bookingIndex].push(conflictBooking.id);
                            conflicts[conflictIndex].push(booking.id);

                            if (!areBookingsEquivalent) {
                                return;
                            }

                            // booking is equivalent to conflictBooking, and vice versa
                            if (!equivalents[conflictIndex]) {
                                equivalents[conflictIndex] = [];
                            }

                            equivalents[bookingIndex].push(conflictBooking.id);
                            equivalents[conflictIndex].push(booking.id);
                        });
                    });

                    var conflictMap = _.map(segmentBookings, (booking, bookingIndex) => {
                        var height = booking.height;
                        if (allowGapBookingInSwimLanes && booking.steps.length) {
                            _.forEach(booking.steps, (step: any) => {
                                if (service.isGapOrResourceStep(step.serviceStepType)) {
                                    height -= step.height;
                                }
                            });
                        }

                        return {
                            id: booking.id,
                            top: booking.top,
                            height: height,
                            conflictIds: conflicts[bookingIndex],
                            equivalentIds: equivalents[bookingIndex]
                        };
                    });

                    conflictMap = _.sortBy(conflictMap, booking => booking.top);
                    conflictMap = _.sortBy(conflictMap, booking => booking.height);
                    conflictMap = _.sortBy(conflictMap, booking => booking.conflictIds.length * -1);

                    // create swim lanes via greedy conflict aversion
                    // each node conflicts with N other nodes
                    // find a path that maximizes the total number of conflicts amongst its nodes that do not conflict with one another

                    var getMaxConflictsResolvedPath = (
                        self: any,
                        bookingIdsInPath: any[],
                        remainingBookingIds: any[],
                        bookingEquivalentIdsInPath = [],
                        resolvedConflictCount = 0,
                        evaluatedPermutationCount = 0
                    ) => {
                        var conflictsWithSelf = _.find(conflictMap, conflict => conflict.id == self);

                        var newResolvedConflictCount = resolvedConflictCount + conflictsWithSelf.conflictIds.length;
                        var newBookingIdsInPath = _.clone(bookingIdsInPath);
                        newBookingIdsInPath.push(self);

                        var newBookingEquivalentIdsInPath = _.union(bookingEquivalentIdsInPath, conflictsWithSelf.equivalentIds);

                        var maxConflictResolvedPath = {
                            bookingIdsInPath: newBookingIdsInPath,
                            bookingEquivalentIdsInPath: newBookingEquivalentIdsInPath,
                            resolvedConflictCount: newResolvedConflictCount,
                            evaluatedPermutationCount: evaluatedPermutationCount
                        };

                        var newRemainingBookingIds = _.reject(
                            remainingBookingIds,
                            id => self == id || _.any(conflictsWithSelf.conflictIds, conflictId => conflictId == id)
                        );

                        if (!newRemainingBookingIds.length)
                        {
                            // permutation fully evaluated, end of recursion. increment counter.
                            maxConflictResolvedPath.evaluatedPermutationCount++;
                        }

                        for (let index = 0; index < newRemainingBookingIds.length; index++) {
                            var nextBooking = newRemainingBookingIds[index];

                            // if current most optimal path already includes the next booking, or an equivalent,
                            // skip evaluating with it once again because order does not matter
                            if (
                                _.any(maxConflictResolvedPath.bookingIdsInPath, id => id == nextBooking) ||
                                _.any(maxConflictResolvedPath.bookingEquivalentIdsInPath, id => id == nextBooking)
                            ) {
                                continue;
                            }

                            const path = getMaxConflictsResolvedPath(
                                nextBooking,
                                newBookingIdsInPath,
                                newRemainingBookingIds,
                                newBookingEquivalentIdsInPath,
                                newResolvedConflictCount,
                                maxConflictResolvedPath.evaluatedPermutationCount
                            );

                            // optimal path resolves the maximum number of conflicts OR
                            // resolves same number of conflicts as current max but includes more bookings
                            if (
                                path.resolvedConflictCount > maxConflictResolvedPath.resolvedConflictCount ||
                                (path.resolvedConflictCount == maxConflictResolvedPath.resolvedConflictCount &&
                                    path.bookingIdsInPath.length > maxConflictResolvedPath.bookingIdsInPath.length)
                            ) {
                                maxConflictResolvedPath = path;
                            }
                            else {
                                maxConflictResolvedPath.evaluatedPermutationCount = path.evaluatedPermutationCount;
                            }

                            // short circuit the recursion once the max permutations threshold is reached
                            if (maxConflictResolvedPath.evaluatedPermutationCount >= globals.distributeBookingsSegmentPermutationMax) {
                                return maxConflictResolvedPath;
                            }
                        }

                        return maxConflictResolvedPath;
                    };

                    var segment = [];

                    var remainingBookingIds = _.map(conflictMap, conflict => conflict.id);

                    while (remainingBookingIds.length) {
                        var path = getMaxConflictsResolvedPath(remainingBookingIds[0], [], remainingBookingIds);

                        segment.push(
                            _.filter(segmentBookings, booking => _.any(path.bookingIdsInPath, id => booking.id == id))
                        );

                        remainingBookingIds = _.reject(remainingBookingIds, id =>
                            _.any(path.bookingIdsInPath, bookingId => bookingId == id)
                        );
                    }

                    segment = _.sortBy(segment, swimLane => swimLane[0].top);

                    distributedBookings.segments.push(segment);
                });

                return distributedBookings;
            },

            GetColumnWidth(column) {
                return column.isExpanded ? globals.columnWidth * column.maxDoubleBooked : globals.columnWidth;
            },

            AdjustColumns(id, setIsExpand = false) {
                // update current column plus all columns to the right
                let loadColumn = false;
                globals.columnBookings.forEach((columnBooking) => {
                    if (id == columnBooking.columnId) {
                        loadColumn = true;
                    }
                    if (loadColumn) {
                        this.AdjustColumnCellsForMultiBooking(columnBooking.columnId, setIsExpand);
                    }
                });
            },
            FindExpandedHeaderColumn(headerId) {
                return _.filter(globals.expandedColumns, (expandedColumn: any) => {
                    return expandedColumn.headerId == headerId;
                });
            },
            RemoveFromExpandedHeaderColumn(headerId) {
                globals.expandedColumns = _.filter(globals.expandedColumns, (expandedColumn: any) => {
                    return expandedColumn.headerId != headerId;
                });
            },
            GetAdjacentCells(booking, alreadyConsidered) {
                var unconsidered = [];

                booking.cellSharingBookings.forEach(cellSharingBooking => {
                    var found = false;
                    alreadyConsidered.forEach(alreadyConsideredBooking => {
                        if (cellSharingBooking == alreadyConsideredBooking) {
                            found = true;
                        }
                    });
                    if (!found) {
                        alreadyConsidered.push(cellSharingBooking);
                        unconsidered.push(cellSharingBooking);
                    }
                });

                if (unconsidered.length > 0) {
                    unconsidered.forEach(unconsideredBook => {
                        service.GetAdjacentCells(unconsideredBook, alreadyConsidered);
                    });
                }
            },
            GetSortedBookings(columnId) {
                var bookings = [];
                var column: any = _.where(globals.columnBookings, { columnId: columnId });
                if (column.length > 0) {
                    column = column[0];
                }
                $(`#${columnId}`)
                    .children('.appointment, .block')
                    .each(function() {
                        const booking = $(this);

                        const actualBooking: any = _.where(column.appointmentsAndBlocks, { id: booking.data('id') })[0];
                        if (actualBooking) {
                            const steps = [];
                            if (actualBooking.steps && actualBooking.steps.length > 0) {
                                const actualBookingSteps = _(actualBooking.steps).filter(step => step.durationWithAddOnsInMinutes > 0);
                                for (let i = 0; i < actualBookingSteps.length; i++) {
                                    const actualBookingStep = actualBookingSteps[i];
                                    steps.push({
                                        serviceStepNumber: actualBookingStep.serviceStepNumber,
                                        serviceStepType: actualBookingStep.serviceStepType,
                                        top: steps.length === 0 ? booking.position().top : steps[i - 1].top + steps[i - 1].height,
                                        height: service.convertMinutesToPixels(actualBookingStep.durationWithAddOnsInMinutes),
                                    });
                                }
                            }
                            bookings.push({
                                id: booking.data('id'),
                                top: booking.position().top,
                                left: booking.position().left,
                                height: $(booking)[0].getBoundingClientRect().height,
                                width: booking.outerWidth(),
                                cellSharingBookings: [],
                                booking: booking,
                                startTime: actualBooking.startDateTime,
                                steps: steps,
                                endTime: !actualBooking.blockTypeId ? undefined : actualBooking.endDateTime,
                            });
                        }
                    });
                return _.sortBy(bookings, booking => booking.top);
            },
            GetCellSharingBookings(mainBooking, sortedBookingToCheck) {
                mainBooking.cellSharingBookings = [];
                for (let i = 0; i < sortedBookingToCheck.length; i++) {
                    const potentialShare = sortedBookingToCheck[i];
                    // Can ignore any bookings that are before main booking
                    if (
                        mainBooking.id == potentialShare.id ||
                        potentialShare.top + potentialShare.height <= mainBooking.top
                    ) {
                        continue;
                    } else if (potentialShare.top >= mainBooking.top + mainBooking.height) {
                        // Have passed main booking so can ignore the rest
                        break;
                    } else {
                        mainBooking.cellSharingBookings.push(potentialShare);
                    }
                }
            },
            CalculatePercentageBooked(relatedColumnIds) {
                globals.columnBookings.forEach(column => {
                    if (relatedColumnIds.indexOf(column.columnId) >= 0) {
                        this.CalculatePercentageBookedForColumn(column);
                    }
                });
            },
            CalculatePercentageBookedForColumn(column) {
                let bookableMinutes = column.bookableMinutes;
                let bookedMinutes = 0;

                const bookableSchedules = _.filter(
                    column.schedules,
                    (schedule: any) => schedule.workType.isBookableTime
                );

                $(`#${column.columnId}`)
                    .children('.appointment, .block')
                    .each(function() {
                        const booking: any = $(this);
                        if (booking.data('type') == globals.appointmentDataTypeId) {
                            bookedMinutes += parseInt(booking.data('bm'));
                        } else {
                            const includeInPercentBooked: boolean = booking.data('ipb');
                            const minutes: number = parseInt(booking.data('m'));
                            if (includeInPercentBooked) {
                                bookedMinutes += minutes;
                            } else {
                                // subtract the number of minutes that overlap scheduled time that is marked "Show as bookable time"
                                const blockId: string = booking.data('id');
                                const block: any = _.findWhere(column.appointmentsAndBlocks, { id: blockId });
                                if (!block) return;

                                const blockStartTime: moment.Moment = moment(block.startDateTime);
                                const blockEndTime: moment.Moment = moment(block.endDateTime);

                                _.forEach(bookableSchedules, (schedule: any) => {
                                    const scheduleStartTime: moment.Moment = moment(schedule.startTime, 'H-m');
                                    const scheduleEndTime: moment.Moment = moment(schedule.endTime, 'H-m');
                                    const scheduleOverlapsBlock: boolean =
                                        (blockStartTime < scheduleEndTime && scheduleStartTime < blockEndTime) ||
                                        (blockStartTime < scheduleStartTime && scheduleEndTime < blockEndTime) ||
                                        (blockEndTime < scheduleStartTime && scheduleEndTime < blockStartTime) ||
                                        (blockEndTime < scheduleEndTime && scheduleStartTime < blockStartTime);

                                    if (!scheduleOverlapsBlock) return;

                                    const overlapStartTime: moment.Moment = moment.max([
                                        scheduleStartTime,
                                        blockStartTime,
                                    ]);
                                    const overlapEndTime: moment.Moment = moment.min([scheduleEndTime, blockEndTime]);
                                    const overlapMinutes: number = overlapEndTime.diff(overlapStartTime, 'minutes');
                                    bookableMinutes -= overlapMinutes;
                                });
                            }
                        }
                    });

                let percentage = bookableMinutes <= 0 ? 0 : bookedMinutes / bookableMinutes;

                this.setColumnBookedPercentage(column, percentage);
            },
            setColumnBookedPercentage(column: any, percentage: number) {
                let width = column.isExpanded
                    ? column.maxDoubleBooked * globals.columnWidth * percentage
                    : globals.columnWidth * percentage;

                if (!column.isExpanded && width >= globals.columnWidth) {
                    width = globals.columnWidth - 1;
                }

                percentage = Math.round(percentage * 100);
                column.bookedPercentage = percentage;
                const backgroundColor = percentage <= 25 ? 'red' : percentage <= 75 ? 'yellow' : 'rgb(78,206,34)';

                $(`#Header${column.columnId} .headerBar`)
                    .empty()
                    .append(
                    `<div class="percentBookedShadow"></div><div id="bookedPercentage" style="background-color:${backgroundColor};position:absolute;width:${width}px;height:12px;"></div><div class="percentBookedLabel">${percentage}%</div>`
                    );
            },
            CalculatePercentageBookedForColumnId(columnId) {
                const column = _.where(globals.columnBookings, { columnId: columnId })[0];

                this.CalculatePercentageBookedForColumn(column);
            },
            setAppointStateIndicator(appointmentServiceId, transitionState, finalState, entityVersion, updateAppointmentOverlays = true) {
                var imageUrl = '';
                const confirm: any = $(`div[data-id='${appointmentServiceId}'] .confirm`);
                const existingEntityVersion = confirm.data('appointmentEntityVersion');
                if (entityVersion && existingEntityVersion && existingEntityVersion > entityVersion) {
                    return;
                }
                confirm.data('appointmentEntityVersion', entityVersion);
                confirm.empty();
                if (finalState && finalState == Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                    $(`div[data-id='${appointmentServiceId}'] .clientName`).css('text-decoration', 'line-through');
                    $(`div[data-id='${appointmentServiceId}'] .serviceName`).css('text-decoration', 'line-through');
                    $(`div[data-id='${appointmentServiceId}'] .serviceShortcut`).css('text-decoration', 'line-through');
                    if (transitionState == Meevo.Model.AppointStateEnum.NoShow) {
                        imageUrl = 'assets/images/appointmentBook/Status_NoShow.svg';
                    } else {
                        imageUrl = 'assets/images/appointmentBook/Status_CheckedOut.svg';
                    }
                } else {
                    switch (transitionState) {
                        case Meevo.Model.AppointStateEnum.RunningLate:
                            imageUrl = 'assets/images/appointmentBook/Status_RunningLate.svg';
                            break;
                        case Meevo.Model.AppointStateEnum.NoShow:
                            imageUrl = 'assets/images/appointmentBook/Status_NoShow.svg';
                            break;
                        case Meevo.Model.AppointStateEnum.CheckedIn:
                            imageUrl = 'assets/images/appointmentBook/Status_CheckedIn.svg';
                            break;
                        case Meevo.Model.AppointStateEnum.Booked:
                            break;
                    }
                }
                if (imageUrl != '') {
                    confirm.append(
                        $compile(
                            `<md-icon style='pointer-events:none;' md-svg-src='${imageUrl}' class='ng-scope small-icon' aria-hidden='true'></md-icon>`
                        )($rootScope)
                    );
                }
                globals.columnBookings.forEach((columnBooking: any) => {
                    if (!columnBooking.appointmentServices) {
                        return;
                    }
                    columnBooking.appointmentServices.forEach((appointmentService: any) => {
                        if (appointmentService.id == appointmentServiceId) {
                            appointmentService.transitionState = transitionState;
                            appointmentService.finalState = finalState;
                        }
                    });
                });
                if (updateAppointmentOverlays) {
                    $rootScope.$broadcast('updateAppointmentOverlays', {});
                }
            },
            detectPhoneMode() {
                if (device.mobile()) {
                    globals.isMobile = true;
                } else {
                    globals.columnWidth = 200;
                    globals.phoneMode = false;
                }
            },
            scroll() {
                const top = globals.scrollContainer.scrollTop();
                // When scrolling need to manually position top of timecontainer since we want it to be fixed horizontally, but scroll vertically.
                $('#timeContainerLeft').scrollTop(top);
                $('#timeContainerRight').scrollTop(top);
                // Need to manually position left of header containers since they need to be fixed vertically, but scroll horizontally
                $('#divRootHeaders').scrollLeft(globals.scrollContainer.scrollLeft());
            },
            clearBook() {
                //globals.scrollContainer.scrollTop(0).scrollLeft(0);
                service.hideSmartAssistant();
                if (globals.divCellHighlight) {
                    globals.divCellHighlight.hide();
                }
                if (globals.divNewBooking) {
                    globals.divNewBooking.hide();
                }
                $('#divRootHeaders, #divColumns').empty();
                globals.lastRequestedDimension = 0;
            },
            getFinalEmployeeFilters(employeeFilters) {
                if (globals.canViewAll) {
                    return employeeFilters;
                } else {
                    return [identityService.current().userId];
                }
            },
            closeDelete() {
                //service.hidePopup("#divDialogDelete");
                modal.hideModal();
            },
            getScheduleForCell(cell, column) {
                for (let schedule of column.schedules) {
                    const scheduleStartMinutes = moment(schedule.startTime, 'H-m').totalMinutes();

                const scheduleEndMinutes = scheduleStartMinutes + schedule.totalMinutes;
                if (
                    globals.highlightedCell.startMinutes >= scheduleStartMinutes &&
                    globals.highlightedCell.startMinutes < scheduleEndMinutes
                ) {
                    return schedule;
                }
            }
        },
        getUserAppointmentBookView() {
            return identityService.current().employeeAppointmentBookViewPreference;
        },
        loadCounts(resourceChanged, employeeChanged, dates, resourceCatId = null): ng.IPromise<any> {
            return service
                .getCountData(resourceChanged, employeeChanged, dates, resourceCatId)
                .then(response => {
                    counts = response.data;
                    service.postLoadCounts();
                })
                .catch(() => {
                    counts = [];
                    return $q.defer().resolve();
                });
        },
        postLoadCounts() {
            if (!counts) {
                counts = [];
            }
            counts.forEach(timeCount => {
                timeCount.id = `${moment(timeCount.startDateTime).hour()}${moment(timeCount.startDateTime).minute()}Count`;
            });
            $('.cellCount').each((index, element) => {
                const wrappedElement = $(element);
                const matchedTimeCount = _(counts).findWhere({ id: wrappedElement.attr('id') });
                wrappedElement.html(matchedTimeCount ? matchedTimeCount.availableCount : 0);
            });
        },
        getCountData(resourceChanged, employeeChanged, dates, resourceCatId = null) {
            if (!globals.businessInfo) {
                return $q.reject();
            }
            const isShowEmployees = globals.businessInfo.showEmployeesAvailableCount && dates.length == 1;
            const isShowResources = globals.businessInfo.showResourcesAvailableCount && dates.length == 1;
            if (isShowEmployees || isShowResources) {
                const businessHours = service.getBusinessHoursForDate(dates[0]);
                if (businessHours) {
                    const date = moment(dates[0]);
                    const startDateTime = moment(businessHours.startTime)
                        .year(date.year())
                        .month(date.month())
                        .date(date.date());
                    const endDateTime = moment(businessHours.endTime)
                        .year(date.year())
                        .month(date.month())
                        .date(date.date());

                        if (globals.isEmployeeView) {
                            if (resourceChanged && isShowResources) {
                                return restServer.loadResourceCounts(
                                    startDateTime.format(),
                                    endDateTime.format(),
                                    $rootScope.appointmentBookIncrement,
                                    resourceCatId
                                );
                            }
                        } else {
                            if (employeeChanged && isShowEmployees) {
                                return restServer.loadEmployeeCounts(
                                    startDateTime.format(),
                                    endDateTime.format(),
                                    $rootScope.appointmentBookIncrement
                                );
                            }
                        }
                    }
                }
                const deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            },
            getBusinessHoursForDate(date, businessHours?): any {
                let dateMoment = moment(date);
                if (!dateMoment.isValid()) {
                    return null;
                }

                let dayOfWeek;
                switch (dateMoment.day()) {
                    case 0:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Sunday;
                        break;
                    case 1:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Monday;
                        break;
                    case 2:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Tuesday;
                        break;
                    case 3:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Wednesday;
                        break;
                    case 4:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Thursday;
                        break;
                    case 5:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Friday;
                        break;
                    case 6:
                        dayOfWeek = Meevo.Model.WeekdayNameEnum.Saturday;
                        break;
                }

                return _.findWhere((businessHours ? businessHours : globals.businessInfo.businessHours), { weekdayName: dayOfWeek });
            },

            expandCollapseEmployeeColumn(headerId, setIsExpand = true) {
                globals.divCellHighlight.hide();
                globals.divNewBooking.hide();
                service.hideSmartAssistant();

                let id = headerId.toLowerCase().split('header')[1];

                var column: any = _.findWhere(globals.columnBookings, { columnId: id });
                let doubleBookings = column && column.isExpanded && column.maxDoubleBooked ? column.maxDoubleBooked : 1;
                if (doubleBookings <= 1) {
                    column.isExpanded = false;
                    if (service.FindExpandedHeaderColumn(headerId).length > 0) {
                        service.RemoveFromExpandedHeaderColumn(headerId);
                    }
                }
                let expandValue = 1;

                if (setIsExpand) {
                    if (!column.isExpanded) {
                        service.addExpandCollapseClass(column, false);
                        doubleBookings = 1;
                        expandValue = -1;
                        if (service.FindExpandedHeaderColumn(headerId).length > 0) {
                            service.RemoveFromExpandedHeaderColumn(headerId);
                        }
                    } else {
                        this.addExpandCollapseClass(column, true);
                        expandValue = 1;
                        if (service.FindExpandedHeaderColumn(headerId).length < 1) {
                            globals.expandedColumns.push({ headerId: headerId, doubleBookedAppts: doubleBookings });
                        }
                    }
                    //column.isExpanded = !column.isExpanded;
                } else {
                    if (column.isExpanded) {
                        this.addExpandCollapseClass(column, true);
                    } else {
                        this.addExpandCollapseClass(column, false);
                    }
                }
                $(`#${headerId}`).css('width', doubleBookings * globals.columnWidth);
                let bookedPercentageWidth = column.bookedPercentage > 100 ? 100 : column.bookedPercentage;
                $(`#${headerId} #bookedPercentage`).css('width', doubleBookings * globals.columnWidth * (bookedPercentageWidth / 100));

                $(`#${id}`).css('width', doubleBookings * globals.columnWidth);
                $(`#${id} .workActivityLabel`).css('width', doubleBookings * globals.columnWidth);
                $(`#${id} .divCurrentTimeBar`).css('width', doubleBookings * globals.columnWidth);

                let rootHeaders = $('#divRootHeaders').children();
                let dimensionTypes = [];
                for (var i = 0; i < rootHeaders.length - 1; i++) {
                    dimensionTypes.push($(rootHeaders[i]).data('dimensionType'));
                    service.expandCollapseHeaderRow(dimensionTypes, column);
                }

                let columnsWidth = $('#divColumns').width();
                $('#divClickOverlay').css('width', columnsWidth);
                $('#divRows').css('width', columnsWidth);
                $('#divAppointmentBookContainer').css('width', columnsWidth);
                this.setHeaderCellRootWidth();
            },
            getDimension(currentDimension, id) {
                if (!currentDimension) {
                    globals.dimensions.forEach(dimension => {
                        if (dimension.id == id) {
                            currentDimension = dimension;
                            return;
                        }
                    });
                } else {
                    currentDimension.innerDimensions.forEach(dimension => {
                        if (dimension.id == id) {
                            currentDimension = dimension;
                            return;
                        }
                    });
                }
                return currentDimension;
            },

            addOverlay(appointmentServiceIds) {
                let appointmentServiceElements = service.getAppointmentServiceElements(appointmentServiceIds);
                // Remove before adding so not adding again if there's one already there
                service.removeOverlay(appointmentServiceIds, appointmentServiceElements, false);
                appointmentServiceElements.find(".nongap, .sideBackground").
                    append(`<div class="appointmentOverlay"></div>`);
            },
            removeOverlay(appointmentServiceIds, appointmentServiceElements?, updateAppointmentOverlays = true) {
                appointmentServiceElements = appointmentServiceElements ||
                    service.getAppointmentServiceElements(appointmentServiceIds);
                appointmentServiceElements.find(".appointmentOverlay").remove();
                if (updateAppointmentOverlays) {
                    $rootScope.$broadcast('updateAppointmentOverlays', {});
                }
            },
            getAppointmentServiceElements(appointmentServiceIds) {
                return $("div[data-id='" + appointmentServiceIds.join("'], div[data-id='") + "']");
            },

            expandCollapseHeaderRow(dimensionTypes, column) {
                let cellIdWidth;
                let cellId;
                const dimensionTypeCellIdPairs = [];
                let currentDimension;

                dimensionTypes.forEach(dimensionType => {
                    switch (dimensionType) {
                        case Meevo.Model.DimensionTypeEnum.Date:
                            dimensionTypeCellIdPairs.push({
                                dimensionType: dimensionType,
                                cellId: replaceAll(column.date, '/', '-'),
                            });
                            currentDimension = service.getDimension(currentDimension, column.date);
                            break;
                        case Meevo.Model.DimensionTypeEnum.Employee:
                            dimensionTypeCellIdPairs.push({
                                dimensionType: dimensionType,
                                cellId: replaceAll(column.employeeId, '-', ''),
                            });
                            currentDimension = service.getDimension(currentDimension, column.employeeId);
                            break;
                        case Meevo.Model.DimensionTypeEnum.Resource:
                            dimensionTypeCellIdPairs.push({
                                dimensionType: dimensionType,
                                cellId: column.resourceId,
                            });
                            currentDimension = service.getDimension(currentDimension, column.resourceId);
                            break;
                        case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                            dimensionTypeCellIdPairs.push({
                                dimensionType: dimensionType,
                                cellId: replaceAll(column.resourceUnitId, '-', ''),
                            });
                            currentDimension = service.getDimension(currentDimension, column.resourceUnitId);
                            break;
                    }
                });

                const cellWidth = service.getHeaderWidth(dimensionTypeCellIdPairs);
                $(`*[data-id=${currentDimension.uniqueId}]`).css('width', cellWidth);
            },
            addExpandCollapseClass(column, isExpandClass = false) {
                const headerId = `Header${column.columnId}`;
                if (isExpandClass) {
                    $(`#${headerId}  #btnExpandCollapse`)
                        .removeClass('collapsed')
                        .addClass('expanded');
                } else {
                    $(`#${headerId}  #btnExpandCollapse`)
                        .removeClass('expanded')
                        .addClass('collapsed');
                }
            },
            getHeaderWidth(dimensionTypeCellIdPairs) {
                let width = 0;
                $.each($('#divColumns').children(), (index, column) => {
                    const wrappedColumn = $(column);
                    let noMatch = false;
                    dimensionTypeCellIdPairs.forEach(dimensionTypeCellIdPair => {
                        if (
                            (dimensionTypeCellIdPair.dimensionType == Meevo.Model.DimensionTypeEnum.Date &&
                                column.id.indexOf(dimensionTypeCellIdPair.cellId) < 0) ||
                            (dimensionTypeCellIdPair.dimensionType == Meevo.Model.DimensionTypeEnum.Employee &&
                                column.id.indexOf(dimensionTypeCellIdPair.cellId) < 0) ||
                            (dimensionTypeCellIdPair.dimensionType == Meevo.Model.DimensionTypeEnum.Resource &&
                                wrappedColumn.data('resourceId') != dimensionTypeCellIdPair.cellId) ||
                            (dimensionTypeCellIdPair.dimensionType == Meevo.Model.DimensionTypeEnum.ResourceUnit &&
                                column.id.indexOf(dimensionTypeCellIdPair.cellId) < 0)
                        ) {
                            noMatch = true;
                            return;
                        }
                    });
                    if (!noMatch) {
                        width += wrappedColumn.outerWidth();
                    }
                });

                return width;
            },
            GetConfirmIndicator(confirmState, employeeType, transitionState) {
                let nonRequestWidthClass = '';
                if (employeeType == Meevo.Model.EmployeeTypeEnum.NonRequest) {
                    nonRequestWidthClass = 'nonRequestWidth';
                }
                let displayStyle = ''
                if (transitionState === Meevo.Model.AppointStateEnum.Pending) {
                    displayStyle = " style='display:none'";
                }
                const html = [];
                html.push("<div class='", nonRequestWidthClass, ' confirm ');
                html.push(this.getConfirmClass(confirmState), "'", displayStyle, "></div>");
                return html.join('');
            },
            getConfirmClass(confirmState) {
                switch (confirmState) {
                    case Meevo.Model.AppointConfirmStateEnum.AwaitingResponse:
                    case Meevo.Model.AppointConfirmStateEnum.LeftMessage:
                    case Meevo.Model.AppointConfirmStateEnum.Queued:
                        return 'backOrange';
                    case Meevo.Model.AppointConfirmStateEnum.Confirmed:
                        return 'backGreen';
                    case Meevo.Model.AppointConfirmStateEnum.Unconfirmed:
                        return 'backRed';
                    case Meevo.Model.AppointConfirmStateEnum.UnableToContact:
                        return 'status-unable-contact';
                    case Meevo.Model.AppointConfirmStateEnum.DoNotConfirm:
                        return 'backBlack';
                    default:
                        return 'backGray';
                }
            },
            isRescheduleRequest(confirmState) {
                if (confirmState === Meevo.Model.AppointConfirmStateEnum.RespondedReschedule) {
                    return true;
                }
            },
            getAdditionalAppointDetailIndicators(appointDetail, appointHeader) {
                let html = [];
                const baseUrl = 'assets/images/appointmentBook';
                let floatingIndicatorCount = 0;

                if (appointDetail.clientHasMultipleServices) {
                    let tooltip = $translate.instant('LABEL_APPOINTMENT_HAS_MULTIPLE_SERVICES');
                    html.push(`<img src="${baseUrl}/Appt_Multiple.png" title="${tooltip}" />`);
                }

                if (appointDetail.appointmentServiceScheduleId) {
                    let tooltip = $translate.instant('LABEL_STANDING_APPOINTMENT');
                    html.push(
                        `<img src="${baseUrl}/Appt_Standing_18.png" title="${tooltip}" class="indicator-standing-appt-img" />`
                    );
                }

                if (appointDetail.prebookSettingId) {
                    let tooltip = $translate.instant('LABEL_REBOOKED');
                    html.push(`<img src="${baseUrl}/Appt_Prebooked_18.png" title='${tooltip}' />`);
                }

                if (appointDetail.hasNote) {
                    let tooltip = $translate.instant('LABEL_HAS_APPOINTMENT_NOTES');
                    html.push(`<img src="${baseUrl}/Appt_HasNotes.png" title="${tooltip}" />`);
                }

                if (appointDetail.clientType === Meevo.Model.ClientTypeEnum.Client) {
                    if (appointDetail.isNewClientForTenant && !identityService.isSingleLocation()) {
                        let tooltip = $translate.instant('LABEL_NEW_CLIENT_TO_ALL_LOCATIONS');
                        html.push(`<img src="${baseUrl}/ApptIcon_NewClientForTenant_18.png" title="${tooltip}" />`);
                    }
                    else if (appointDetail.isNewClientForLocation) {
                        let tooltip = $translate.instant('LABEL_NEW_CLIENT_TO_LOCATION');
                        html.push(`<img src="${baseUrl}/ApptIcon_NewClient_18.png" title="${tooltip}" />`);
                    }
                    else if (appointDetail.isNewClientForEmployee && appointDetail.employeeId) {
                        let tooltip = $translate.instant('LABEL_NEW_CLIENT_TO_EMPLOYEE');
                        html.push(`<img src="${baseUrl}/ApptIcon_NewClientForEmployee_18.png" title="${tooltip}" />`);
                    }
                }

                if (appointDetail.bookingMethod === Meevo.Model.BookingMethodEnum.Online) {
                    let url = baseUrl;
                    let tooltip;

                    if (appointDetail.hasDeposit || appointDetail.depositAmount) {
                        url += `/icon_cloudarrow_deposit.png`;
                        tooltip = $translate.instant('LABEL_BOOKED_ONLINE_WITH_DEPOSIT');
                    } else {
                        url += `/icon_cloudarrow.png`;
                        tooltip = $translate.instant('LABEL_BOOKED_ONLINE');
                    }

                    html.push(
                        `<img class="onlineBooked" src="${url}" style="float:right" title="${tooltip}" />`
                    );
                    floatingIndicatorCount++;
                }

                if (appointDetail.clientTypeId && appointDetail.clientTypeColor) {
                    html.push(
                        `<span id="clientTypeContainer_${appointDetail.id}" style="display:inline-block; vertical-align:top;" />`
                    );
                }

                if (appointDetail.genderPreference) {
                    let tooltipGenderPreference = $translate.instant('LABEL_GENDER_PREFERENCE');
                    switch (appointDetail.genderPreference) {
                        case Meevo.Model.GenderPreferenceEnum.FemaleOnly:
                            html.push(
                                `<img src="${baseUrl}/Gender_FemaleOnly_18.png" title="${tooltipGenderPreference}" />`
                            );
                            break;
                        case Meevo.Model.GenderPreferenceEnum.FemalePreferred:
                            html.push(
                                `<img src="${baseUrl}/Gender_Femalepreferred_18.png" title="${tooltipGenderPreference}" />`
                            );
                            break;
                        case Meevo.Model.GenderPreferenceEnum.MaleOnly:
                            html.push(
                                `<img src="${baseUrl}/Gender_MaleOnly_18.png" title="${tooltipGenderPreference}" />`
                            );
                            break;
                        case Meevo.Model.GenderPreferenceEnum.MalePreferred:
                            html.push(
                                `<img src="${baseUrl}/Gender_MalePreferred_18.png" title="${tooltipGenderPreference}" />`
                            );
                            break;
                        case Meevo.Model.GenderPreferenceEnum.NonbinaryPreferred:
                            html.push(
                                `<img src="${baseUrl}/Gender_NonbinaryPreferred_18.png" title="${tooltipGenderPreference}" />`
                            );
                            break;
                    }
                }

                if (!appointDetail.employeePerformsService) {
                    let tooltip = $translate.instant('LABEL_EMPLOYEE_DOES_NOT_PERFORM_SERVICE');
                    html.push(
                        `<span class="alertIcon high" title="${tooltip}" style="display:inline-block; background-size: 14px 16px; width:14px; height: 16px;"></span>`
                    );
                }

                if (appointDetail.isMinor) {
                    let tooltip = $translate.instant('LABEL_MINOR');
                    html.push(
                        `<img src="${baseUrl}/minor_indicator.svg" title="${tooltip}" style="width: 15px; height: 15px;" />`
                    );
                }

                if (
                    appointDetail.transitionState === Meevo.Model.AppointStateEnum.Pending &&
                    !appointDetail.appointmentRequestNotifyViaText
                ) {
                    let tooltip = $translate.instant('LABEL_CALL');
                    html.push(
                        `<img src="assets/images/icons/call_iconsml.png" class='call' title="${tooltip}" style="width: 15px; height: 15px; cursor: auto;" />`
                    );
                }

                if (appointDetail.reBookCount > 0) {
                    let tooltip = $translate.instant('LABEL_REBOOKED');
                    html.push(
                        `<img src="${baseUrl}/rebook_indicator.svg" title="${tooltip}" style="width: 15px; height: 15px;" />`
                    );
                }

                // Add an element so iconContainer height is not zero. Since Membership icon is added elswhere, we need to skip this step if there is Membership
                if (html.length && html.length === floatingIndicatorCount && !appointDetail.membershipDisplayName) {
                    html.push(
                        `<div style="height: 15px;"></div>`
                    );
                }

                return html.join('');
            },
            loadMembershipTypeIcon() {
                if (this.membershipTypeRibbon) {
                    return;
                }

                const deferred = $q.defer();

                // Need to retrieve svg so that the fill color can be dynamically changed
                $.get(
                    'assets/images/appointmentBook/meevo-appointment-ribbon.svg',
                    data => {
                        const svg: any = $(data).find('svg');
                        this.membershipTypeRibbon = $('<p>').append(svg);
                        deferred.resolve();
                    },
                    'xml'
                );

                return deferred.promise;
            },
            addMembershipTypeIndicator(html, appointDetail) {
                if (appointDetail.membershipTypeRibbonColor) {
                    html.push(`<div class="membershipTypeIcon" title="${appointDetail.membershipDisplayName ? appointDetail.membershipDisplayName : ''}"><div style="background-color:${appointDetail.membershipTypeRibbonColor}"></div></div>`);
                }
            },
            convertMinutesToPixels(minutes, useFloor: boolean = false) {
                // useFloor = true probably means the caller is not normalizing to the book interval
                // TODO: eliminate need for useFloor
                const minutesByIncrement = minutes / $rootScope.appointmentBookIncrement;
                return (useFloor ? Math.floor(minutesByIncrement) : minutesByIncrement) * globals.cellHeight;
            },
            convertPixelsToMinutes(pixels) {
                return Math.floor(pixels / globals.cellHeight) * $rootScope.appointmentBookIncrement;
            },
            updateStepsOnChangeFilter(cutCopyIds: any[]) {

                var cutCopyContainer = $('.cutcopyWrapper');

                if (!cutCopyContainer || cutCopyContainer.length < 1) {
                    return;
                }

                cutCopyIds.forEach(cutCopyId => {
                    var id = cutCopyId.id;
                    var appointmentElement = $(cutCopyContainer).find(`[data-id='${id}']`).first();
                    if (appointmentElement.length < 1) {
                        id = cutCopyId.appointmentServiceId;
                        appointmentElement = $(cutCopyContainer).find(`[data-clipboard-action-id='${id}']`).first();
                    }

                    var appointDetail = cutCopyId.appointServiceDetail;

                    if (appointmentElement.length < 1 || !appointDetail) {
                        return;
                    }

                    var isStepVisible = _(appointDetail.steps)
                        .any(step => step.durationWithAddOnsInMinutes > 0 &&
                            !service.isGapOrResourceStepInEmployeeView(step.serviceStepType));

                    if (!isStepVisible) {
                        return;
                    }

                    var appointDetailHtml = service.buildAppointmentHtml(appointDetail, null).join(' ');
                    $(appointmentElement).html(appointDetailHtml);
                    service.removeIndicatorsForCutCopyClipboard(appointmentElement);
                    service.resizeAppointmentSlices(appointmentElement);
                });
            },
            updateStepsOnCopyPaste(appointDetail) {
                var appointServiceElement = $(`div[data-id='${appointDetail.id}']`).first();

                const areAllStepsHidden = _(appointDetail.steps)
                    .all(step => service.isGapOrResourceStepInEmployeeView(step.serviceStepType));

                if (areAllStepsHidden) {
                    appointServiceElement.remove();
                }
            },
            buildAppointmentHtml(appointDetail, appointHeader) {
                const html: string[] = [];

                if (_(appointDetail.steps).all(step => service.isGapOrResourceStepInEmployeeView(step.serviceStepType))) {
                    return html;
                }

                const steps = [];
                let step;
                _.sortBy(appointDetail.steps, (step: any) => step.serviceStepNumber).forEach(appointDetailStep => {
                    if (step == undefined || step.type != appointDetailStep.serviceStepType) {
                        step = {
                            type: appointDetailStep.serviceStepType,
                            height: 0,
                            serviceStepNumber: appointDetailStep.serviceStepNumber,
                            durationInMinutes: appointDetailStep.durationInMinutes,
                        };
                        steps.push(step);
                    }
                    step.height += service.convertMinutesToPixels(appointDetailStep.durationWithAddOnsInMinutes);
                });

                const appointmentColors = this.getAppointmentColors(appointDetail);
                let sideBarBackgroundColorStyle = appointmentColors.sideBarBackgroundColorStyle;
                let foregroundColorStyle = appointmentColors.foregroundColorStyle;
                let backgroundColorStyle = appointmentColors.backgroundColorStyle;

                let detailsWritten = false;

                this.addMembershipTypeIndicator(html, appointDetail);

                let isGapDesigned = false;
                let requestNonRequestClass =
                    appointDetail.employeeType === Meevo.Model.EmployeeTypeEnum.NonRequest ? 'nonRequest' : 'request';
                let borderClass = 'border';
                let borderClassSideback = '';
                let borderClassNongap = '';
                let stepHeight;
                let stepTop = 0;
                let rescheduleRequestClass = '';
                let labelContinued = ' ' + $translate.instant("LABEL_APPOINTMENT_BOOK_CONTINUED");

                // if its chromeversion 48 or 49
                let chromeIssueClass = getChromeVersionIssue() ? 'chrome-issue' : '';

                steps.forEach((step: any, stepIndex: number) => {
                    if (service.isGapOrResourceStepInEmployeeView(step.type)) {
                        borderClassSideback = borderClass + '-l';
                        html.push(
                            `<div class="sideBackground gapSideBackground ${borderClassSideback}" data-step-number="${step.serviceStepNumber}" `,
                            `style="border-right:1px solid black;float:left;width:${globals.appointmentLeftBarWidth}px;${sideBarBackgroundColorStyle};height:${step.height}px;pointer-events:auto;"></div>`
                        );
                        const indent =
                            appointDetail.transitionState !== Meevo.Model.AppointStateEnum.Pending ||
                            appointDetail.transitionState === Meevo.Model.AppointStateEnum.WalkInPending;
                        html.push(
                            `<div class="gap" `,
                            `data-step-number="${step.serviceStepNumber}" data-m="${step.durationInMinutes}" data-step-type="${step.type}" `,
                            `style="margin-left:${indent ? globals.appointmentLeftBarWidth : 0}px;width:auto;height:${step.height}px;pointer-events:none;">`,
                            `</div>`
                        );
                        isGapDesigned = true;
                    } else {
                        stepHeight = step.height;
                        if (stepIndex === 0 && stepIndex === steps.length - 1) {
                            borderClassSideback = borderClass + '-tlb';
                        } else if (stepIndex === 0) {
                            borderClassSideback = borderClass + '-tl';
                        } else if (stepIndex === steps.length - 1) {
                            borderClassSideback = borderClass + '-lb';
                        } else {
                            borderClassSideback = borderClass + '-l';
                        }
                        borderClassNongap = borderClass + '-trb';

                        html.push(
                            `<div class="sideBackground ${borderClassSideback}" data-step-number="${step.serviceStepNumber}" `,
                            `style="border-right:1px solid black;float:left;width:${globals.appointmentLeftBarWidth}px;${sideBarBackgroundColorStyle};height:${stepHeight}px;pointer-events:auto;">`);

                        if (!detailsWritten) {
                            html.push(
                                this.GetConfirmIndicator(
                                    appointDetail.appointmentConfirmState,
                                    appointDetail.employeeType,
                                    appointDetail.transitionState
                                )
                            );
                        }

                        if (appointDetail.appointmentConfirmState === Meevo.Model.AppointConfirmStateEnum.RespondedReschedule) {
                            backgroundColorStyle = '';
                            rescheduleRequestClass = 'rescheduleRequest';
                            foregroundColorStyle = 'black';
                        }

                        html.push(
                            '</div>',
                            `<div class="step nongap ${borderClassNongap} ${chromeIssueClass} ${requestNonRequestClass} ${rescheduleRequestClass}" `,
                            `data-step-number="${step.serviceStepNumber}" data-m="${step.durationInMinutes}" data-step-type="${step.type}" `,
                            `style="margin-left:${globals.appointmentLeftBarWidth}px;width:auto;height:${stepHeight}px;${backgroundColorStyle};pointer-events:auto;">`
                        );

                        let clientDisplayName = $translate.instant(_.escape(appointDetail.clientDisplayName));
                        html.push(
                            `<div class="clientName" id="clientName" style="${foregroundColorStyle}">${clientDisplayName}${isGapDesigned && detailsWritten ? labelContinued : ''}</div>`,
                            `<div class="content" style="${foregroundColorStyle}">`
                        );
                        
                        if (!detailsWritten) {
                            let containerHtml = [];

                            const displayName = appointDetail.serviceDisplayName;
                            const addOnCountDisplay =
                                appointDetail.addOnCount > 0 ? ` |${appointDetail.addOnCount}A|` : '';
                            const style = !!addOnCountDisplay ? "style='float:left;width:80%;' " : '';

                            containerHtml.push(
                                "<div class='serviceNameContainer'>",
                                `<span class='serviceName'${style}>`,
                                _.escape(displayName),
                                '</span>'
                            );

                            if (addOnCountDisplay) {
                                containerHtml.push("<span id='addOnCountDisplay'>", addOnCountDisplay, '</span>');
                            }

                            containerHtml.push('</div>');

                            if (!globals.isEmployeeView) {
                                let unassignedEmployee = $translate.instant('LABEL_UNASSIGNED_EMPLOYEE');
                                let employeeCode = appointDetail.employeeCode
                                    ? appointDetail.employeeCode
                                    : `[${unassignedEmployee}]`;
                                containerHtml.push(`<span class='empName empResName'>${employeeCode}<br/></span>`);
                            }

                            containerHtml.push(
                                "<span class='serviceShortcut'>",
                                appointDetail.serviceShortcut,
                                '<br/></span>'
                            );

                            if (
                                appointDetail.transitionState === Meevo.Model.AppointStateEnum.Pending ||
                                appointDetail.transitionState === Meevo.Model.AppointStateEnum.WalkInPending
                            ) {
                                containerHtml.push("<span class='appointState'></span>");
                            }

                            if (globals.isEmployeeView && appointDetail.resource) {
                                containerHtml.push(
                                    `<span class='resName empResName'>${appointDetail.resource.shortcut}<br/></span>`
                                );
                            }

                            if (globals.businessInfo.showAddressOnAppointmentBook && appointDetail.city) {
                                containerHtml.push(
                                    `<span class='address'>${_.escape(appointDetail.city)}<br/>${
                                    appointDetail.zipCode
                                    }</span>`
                                );
                            }

                            html.push(containerHtml.join(''));
                            html.push(
                                `<div id="iconsContainer" style="line-height: 0; max-height: 15px; max-width: ${step.height === 35 ? 'calc(100% - 13px)' : '100%'}">`,
                                this.getAdditionalAppointDetailIndicators(appointDetail, appointHeader),
                                `</div>`
                            );

                            detailsWritten = true;
                        }
                        html.push('</div></div>');
                    }
                    stepTop += step.height;
                });

                return html;
            },
            getAppointmentServiceWithData(appointmentService, appointment, altId: string = null, top: number = 0) {
                // TODO: investigate using only the startDatetime property on the client-side
                appointmentService.startTime = appointmentService.startDateTime;
                appointmentService.startDate = moment(appointmentService.startDateTime)
                    .startOf('day')
                    .toDate();

                let appointmentHeight = 0;
                let bookedMinutes = 0;

                appointmentService.steps.forEach(appointDetailStep => {
                    appointmentHeight += service.convertMinutesToPixels(appointDetailStep.durationWithAddOnsInMinutes);
                    if (!service.isGapOrResourceStep(appointDetailStep.serviceStepType)) {
                        bookedMinutes += appointDetailStep.durationWithAddOnsInMinutes;
                    }
                });

                appointmentService.steps = _.filter(
                    appointmentService.steps,
                    (step: any) => step.durationWithAddOnsInMinutes > 0
                );

                const appointmentHtml = this.buildAppointmentHtml(appointmentService, appointment);

                const newId = altId || appointmentService.id;

                let dataAttr = ` data-type='${globals.appointmentDataTypeId}'
data-bm='${bookedMinutes}'
data-appointment-id='${appointment.id}'
data-appointment-entity-version='${appointment.entityVersion}'
data-fs='${appointmentService.finalState}'
data-ts='${appointmentService.transitionState}'
data-id='${newId}'
data-height='${appointmentHeight}' `;

                if (appointmentService.employeeId) {
                    dataAttr += `data-employee-id='${appointmentService.employeeId}' `;
                }

                if (appointmentService.resourceUnitId) {
                    dataAttr += `data-resource-unit-id='${appointmentService.resourceUnitId}' `;
                }

                if (appointmentService.appointmentServiceScheduleId) {
                    dataAttr += `data-appointment-service-schedule-id='${
                        appointmentService.appointmentServiceScheduleId
                        }' `;
                }

                let transitionState: string;

                switch (appointmentService.transitionState) {
                    case Meevo.Model.AppointStateEnum.Pending:
                        transitionState = ' pendingAppointment';
                        break;

                    case Meevo.Model.AppointStateEnum.WalkInPending:
                        transitionState = ' walkInPendingAppointment';
                        break;

                    default:
                        transitionState = '';
                        break;
                }

                const html = this.GetDiv({
                    className: `draggable appointment${transitionState} client_${appointmentService.clientId}`,
                    content: appointmentHtml.join(''),
                    data: dataAttr,
                    style: `height:${appointmentHeight}px;width:${globals.columnWidth - globals.leftRightBorderWidth}px;top:${top}px;z-index:${globals.zIndexBooking};pointer-events:none`,
                });

                return html;
            },
            buildAppointmentHtmlWithData(
                appointmentService,
                appointment,
                containerId: string,
                altId: string = null,
                top: number = 0
            ) {
                //console.log('buildAppointmentHtmlWithData');
                //console.time('buildAppointmentHtmlWithData');

                const html = service.getAppointmentServiceWithData(appointmentService, appointment, altId, top);

                if (html.length > 0) {
                    $(containerId || '#divAppointmentBookContainer').append(html);
                }

                const newId = altId || appointmentService.id;

                const htmlElem = service.updateAppointmentService(newId, appointmentService, appointment);

                //console.timeEnd('buildAppointmentHtmlWithData');

                return htmlElem;
            },
            updateAppointmentService(appointmentServiceId, appointmentService, appointment) {
                //console.time('updateAppointemntService:'+appointmentServiceId);

                let htmlElem = $(`div[data-id='${appointmentServiceId}']`);

                if (appointmentService) {
                    if (appointmentService.membershipTypeRibbonColor) {
                        let ribbon = $compile(`<md-icon md-svg-icon="assets/images/appointmentBook/meevo-appointment-ribbon.svg" style="fill: ${appointmentService.membershipTypeRibbonColor}"></md-icon>`)($rootScope)
                        $(htmlElem.find(".membershipTypeIcon")).append(ribbon);
                    }

                    service.resizeMembershipTypeIcon(htmlElem, appointmentService);
                }

                service.resizeAppointmentSlices(htmlElem);

                if (appointmentService &&
                    (appointmentService.transitionState !== Meevo.Model.AppointStateEnum.Booked ||
                        appointmentService.finalState === Meevo.Model.AppointFinalStateEnum.CheckedOut)) {
                    service.setAppointStateIndicator(
                        appointmentServiceId,
                        appointmentService.transitionState,
                        appointmentService.finalState,
                        appointment.entityVersion,
                        false
                    );
                }

                //console.timeEnd('updateAppointemntService:'+appointmentServiceId);

                return htmlElem;
            },
            resizeMembershipTypeIcon(appointmentElem, appointmentService) {
                if (appointmentService.membershipTypeRibbonColor) {
                    let steps = appointmentElem.find('.nongap, .gap');
                    if (steps.length > 0) {
                        let stepHeight = steps.first().height();
                        appointmentElem.find('.membershipTypeIcon > div').height(stepHeight > 18 ? 18 : stepHeight - 2);
                    }
                }
            },
            setHeaderCellRootWidth() {
                let rootHeaders = $('#divRootHeaders').children();
                let dimensionTypeCellIdPairs = [];
                for (var i = 0; i < rootHeaders.length - 1; i++) {
                    let last = $(rootHeaders[i])
                        .find('.headerCellRoot')
                        .last();
                    if (last.length === 0) {
                        continue;
                    }
                    let cellIdWidth;
                    switch ($(rootHeaders[i]).data('dimensionType')) {
                        case Meevo.Model.DimensionTypeEnum.Date:
                            cellIdWidth = last.attr('id');
                            break;
                        case Meevo.Model.DimensionTypeEnum.Employee:
                            cellIdWidth = replaceAll(last.attr('id'), '-', '');
                            break;
                        case Meevo.Model.DimensionTypeEnum.Resource:
                            cellIdWidth = last.attr('id');
                            break;
                        case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                            cellIdWidth = replaceAll(last.attr('id'), '-', '');
                            break;
                    }

                    dimensionTypeCellIdPairs.push({
                        dimensionType: $(rootHeaders[i]).data('dimensionType'),
                        cellId: replaceAll(cellIdWidth, 'Cell', ''),
                    });

                    let cellWidth = this.getHeaderWidth(dimensionTypeCellIdPairs);
                    last.css('width', cellWidth);

                    if ($('#divColumns').width() < $('#divAppointmentBookScrollContainer').width()) {
                        $('#divRootHeaders')
                            .width($('#divColumns').width())
                            .css('overflow', 'visible');
                        var modalWidth = globals.timeColumnWidth * 2;
                        if ($('#divCutCopy').is(':visible')) {
                            modalWidth += 250;
                        }
                        //$('#standardCellTopRight').css('width', `${modalWidth - globals.timeColumnWidth}px`);
                    } else {
                        if (
                            $('#divAppointmentBookScrollContainer').get(0).scrollWidth >
                            $('#divAppointmentBookScrollContainer').innerWidth()
                        ) {
                            last.css('width', last.width() + 100);
                        }
                        $('#divRootHeaders')
                            .css('width', $('#divAppointmentBookScrollContainer').width())
                            .css('overflow', 'hidden');
                    }
                }

                $('#appt-book-pager>div:first-child').css('bottom', '0');
                if ($('#divColumns').width() > $('#divAppointmentBookScrollContainer').width()) {
                    $('#appt-book-pager>div:first-child').css('bottom', '18px');
                }
                if ($('#divRootHeaders').length > 0) {
                    $('#divRootHeaders').scrollLeft(globals.scrollContainer.scrollLeft());
                }
            },
            normalize(a, b) {
                return Math.ceil(a / b) * b;
            },
            normalizeMinutes(minutes) {
                return this.normalize(minutes, $rootScope.appointmentBookIncrement);
            },
            writeTimeStructure(startTime, endTime, isExpand: boolean = false) {
                //console.log('writeTimeStructure');
                //console.time('writeTimeStructure');

                let intervals = 0;
                let startMin = this.normalizeMinutes(startTime.hours() * 60 + startTime.minutes());
                let endMin = this.normalizeMinutes(endTime.hours() * 60 + endTime.minutes());

                // Write time column

                const divTimeContainer = [];
                const divTimeContainerRight = [];
                const divRows = [];
                const lowZoomStyleAdjustment = this.getCellTimePaddingAdjustment(+globals.cellHeightPercent);
                const timeStyle = `style='height:${globals.cellHeight}px;flex:${globals.timeCellWidth}px;${lowZoomStyleAdjustment}'`;
                const cellCountStyle = `class="cellCount" style="flex:${globals.countWidth}px;height:${globals.cellHeight}px;${lowZoomStyleAdjustment}"`;
                const isCellCountVisible = service.isCellCountVisible();
                const wrapperStyle = `height:${globals.cellHeight}px;z-index:${globals.zIndexTime};`;
                const rowStyle = `height:${globals.cellHeight}px;`;

                for (let minutes = startMin; minutes < endMin; minutes += $rootScope.appointmentBookIncrement) {
                    const startHour = Math.floor(minutes / 60);
                    const currentIntervalMin = minutes % 60;

                    const backgroundColorClass = currentIntervalMin == 0 ? 'timePurple' : 'timeGray';
                    const timeTemplate = `<div class="standardCellTime ${backgroundColorClass}" ${timeStyle}>${service.GetTimeDisplay(startHour, currentIntervalMin)}</div>`;
                    if (isCellCountVisible) {
                        const cellCountTemplate = `<div id="${startHour}${currentIntervalMin}Count" ${cellCountStyle}></div>`;

                        divTimeContainer.push(service.GetDiv({
                            className: 'timeRow',
                            content: timeTemplate + cellCountTemplate,
                            style: wrapperStyle,
                        }));

                        divTimeContainerRight.push(service.GetDiv({
                            className: 'timeRow',
                            content: cellCountTemplate + timeTemplate,
                            style: wrapperStyle,
                        }));
                    } else {
                        const html = service.GetDiv({
                            className: 'timeRow',
                            content: timeTemplate,
                            style: wrapperStyle,
                        });

                        divTimeContainer.push(html);
                        divTimeContainerRight.push(html);
                    }

                    const rowColorClass = currentIntervalMin == 0 ? ' major' : '';

                    divRows.push(service.GetDiv({
                        className: `row${rowColorClass}`,
                        id: service.GenerateRowId(startHour, currentIntervalMin),
                        data: ` data-min="${minutes}"`,
                        style: rowStyle,
                    }));

                    intervals++;
                }

                if (!isExpand) {
                    $('#divTimeContainer, #divTimeContainerRight, #divRows').empty();
                }

                if (divTimeContainer.length > 0) {
                    $('#divTimeContainer').append(divTimeContainer);
                }
                if (divTimeContainerRight.length > 0) {
                    $('#divTimeContainerRight').append(divTimeContainerRight);
                }
                if (divRows.length > 0) {
                    $('#divRows').append(divRows);
                }

                $('#divTimeContainer, #divTimeContainerRight, #divRows').height('auto');
                globals.timeContainerHeight = $('#divTimeContainer').height();
                $('#divAppointmentBookContainer, #divColumns, #divClickOverlay').css('height', globals.timeContainerHeight);

                return intervals;
            },
            GenerateRowId(hour, interval) {
                return `${hour}-${interval}`;
            },
            GetTimeDisplay(tempStartHour, currentInterval) {
                const isTimeFormat24 = appSettings.APP_TIME_FORMAT === Meevo.Model.TimeFormatEnum.TimeFormat24;

                const interval = currentInterval === 0
                    ? isTimeFormat24 ? ':00' : ''
                    : ':' + (currentInterval < 10 ? "0" + currentInterval : currentInterval);

                const display = isTimeFormat24
                    ? `${tempStartHour}${interval}`
                    : `${(tempStartHour % 12) === 0 ? '12' : ('' + (tempStartHour % 12))}${interval}${appSettings.APP_AMPMS[tempStartHour >= 12 ? 1 : 0]}`;

                return display;
            },
            expandBook(startDateTime, endDateTime) {
                let newEndTime;
                endDateTime.add(60 + service.getOffsetMinutes(moment(endDateTime)), 'm');
                // If the new end time goes into the next day, set the end time to the end of today
                if (moment(endDateTime).startOf('day') > moment(startDateTime).startOf('day')) {
                    newEndTime = moment('23:59', 'H:m');
                } else if (endDateTime.time() > globals.bookEndTime.time()) {
                    newEndTime = endDateTime;
                }

                if (newEndTime) {
                    service.lastScheduleIds.forEach((id) => {
                        const schedule = $('#' + id);
                        const totalMinutes = newEndTime.totalMinutes() - globals.bookEndTime.totalMinutes() + 1;
                        const newHeight = schedule.height() + service.convertMinutesToPixels(totalMinutes);
                        schedule.height(newHeight);
                    });
                    const startTime = moment(globals.bookEndTime);
                    globals.bookEndTime = newEndTime;
                    service.writeTimeStructure(startTime, newEndTime, true);
                    service.postLoadCounts();

                    service.recalculateScrollbarHeight();
                }
            },
            isCellCountVisible() {
                if (!globals.businessInfo) {
                    return false;
                }
                return globals.isDayView && ((globals.isEmployeeView && globals.businessInfo.showResourcesAvailableCount) || (!globals.isEmployeeView && globals.businessInfo.showEmployeesAvailableCount));
            },
            recalculateScrollbarHeight() {
                const container = $('#divAppointmentBookScrollContainer');
                if (container.length === 0 || !container.is(":visible")) {
                    return;
                }

                const scrollbarHeight = Math.max(container.height() - container[0].clientHeight, 0);
                const $divTimeContainer = $('#divTimeContainer');
                const $divTimeContainerRight = $('#divTimeContainerRight');

                $divTimeContainer.height('auto').height($divTimeContainer.height() + scrollbarHeight);
                $divTimeContainerRight.height('auto').height($divTimeContainerRight.height() + scrollbarHeight);

            service.scroll();
        },
        checkReturnToState(caller: any, requireRefresh: any) {
            if (caller) {
                if (caller.returnStateInfo && caller.returnStateInfo.returnStateSection) {
                    $rootScope.$broadcast('gotoState',
                        {
                            stateName: caller.returnStateInfo.returnStateSection,
                            stateParams: {
                                id: caller.returnStateInfo.id,
                                initialEditSection: caller.returnStateInfo.initialEditSection,
                                actionState: caller.returnStateInfo.actionState,
                                targetState: caller.returnStateInfo.targetState
                            }
                        });
                    $rootScope.$broadcast('appointmentChanged',
                        {
                            stateParams: {
                                requireRefresh: requireRefresh,
                                stateName: caller.returnStateInfo.returnStateSection
                            }
                        });
                }
                caller.returnStateInfo = undefined;
            }
        },
        verifyNewBookingAllowed(selectedDate: string | moment.Moment): boolean {

            if (typeof selectedDate === 'string') {
                selectedDate = moment(selectedDate, 'M-D-YYYY');
            }

            selectedDate = selectedDate.startOf('day').utcOffset(0, true);
            const minimumAllowedDate = moment.utc().add(moment.duration(globals.timeZoneOffset)).startOf('day').add(globals.daysBeforeBookingIsAllowed, 'days');

            return selectedDate.isSame(minimumAllowedDate) || selectedDate.isAfter(minimumAllowedDate);
        },
        getAnonymousClientName(clientType, clientDisplayName = undefined) {
            switch (clientType) {
                case Meevo.Model.ClientTypeEnum.AnonymousMale:
                    return $translate.instant("LABEL_ANONYMOUS_MALE");
                case Meevo.Model.ClientTypeEnum.AnonymousFemale:
                    return $translate.instant("LABEL_ANONYMOUS_FEMALE");
                case Meevo.Model.ClientTypeEnum.AnonymousOther:
                    return $translate.instant("LABEL_ANONYMOUS_OTHER");
                default:
                    return clientDisplayName || $translate.instant("LABEL_ANONYMOUS_OTHER");
            }
        },
        isGapOrResourceStep(stepType: Meevo.Model.ServiceStepTypeEnum): boolean {
            return (stepType === Meevo.Model.ServiceStepTypeEnum.Gap ||
                stepType === Meevo.Model.ServiceStepTypeEnum.Resource);
        },
        isGapOrResourceStepInEmployeeView(stepType: Meevo.Model.ServiceStepTypeEnum): boolean {
            return globals.isEmployeeView && service.isGapOrResourceStep(stepType);
        },
        removeIndicatorsForCutCopyClipboard(clipboardElement) {
            clipboardElement.find("img[class='indicator-standing-appt-img']").remove();
            var onlineBookedIndicator = clipboardElement
                .find('.step')
                .find('.onlineBooked');
            if (onlineBookedIndicator.length > 0) {
                $(onlineBookedIndicator).remove();
            }
        },
        resizeAppointmentSlices(appointmentElement) {
            var clientNameHeight = $(appointmentElement).find('.clientName').height() || 0;
            var iconsContainerHeight = service.getIconsContainerHeight(appointmentElement);
            var serviceNameHeight = $(appointmentElement).find('.serviceNameContainer').height() || 0;
            var serviceShortcutHeight = $(appointmentElement).find('.serviceShortcut').height() || 0;
            var appointStateHeight = $(appointmentElement).find('.appointState').height() || 0;
            var empResNameHeight = $(appointmentElement).find('.empResName').height() || 0;
            var addressHeight = $(appointmentElement).find('.address').height() || 0;

            const iconsContainerCutoffThreshold = 0.85;
            iconsContainerHeight = iconsContainerHeight * iconsContainerCutoffThreshold;

            let nonGapSteps = [];
            $(appointmentElement)
                .find('.nongap')
                .each((index, element) => {
                    const nonGapStep = $(element);
                    if (nonGapStep.height() > 0) {
                        nonGapSteps.push(nonGapStep);
                    }
                });

            if (nonGapSteps.length > 0) {
                let firstNonGapStep = nonGapSteps[0];
                let firstNonGapHeight = firstNonGapStep.height();

                let hideElements = [];
                let totalHeight = clientNameHeight;

                totalHeight += iconsContainerHeight;
                if (firstNonGapHeight < totalHeight) {
                    hideElements.push('#iconsContainer');
                }

                totalHeight += serviceNameHeight;
                if (firstNonGapHeight < totalHeight) {
                    hideElements.push('.serviceNameContainer');
                }

                if (!globals.isEmployeeView) {
                    totalHeight += empResNameHeight;
                    if (firstNonGapHeight < totalHeight) {
                        hideElements.push('.empResName');
                    }
                }

                totalHeight += serviceShortcutHeight;
                if (firstNonGapHeight < totalHeight) {
                    hideElements.push('.serviceShortcut');
                }

                totalHeight += appointStateHeight;
                if (firstNonGapHeight < totalHeight) {
                    hideElements.push('.appointState');
                }

                if (globals.isEmployeeView) {
                    totalHeight += empResNameHeight;
                    if (firstNonGapHeight < totalHeight) {
                        hideElements.push('.empResName');
                    }
                }

                totalHeight += addressHeight;
                if (firstNonGapHeight < totalHeight) {
                    hideElements.push('.address');
                }

                $(appointmentElement).find(hideElements.join(',')).hide();

                shrinkNonGapSteps(nonGapSteps, clientNameHeight);
            }
        },
        getIconsContainerHeight(appointmentElement): number {
            const iconsContainer = $(appointmentElement).find('#iconsContainer');
            const iconsContainerChildren = iconsContainer.children();
            return iconsContainerChildren.length > 0 ?
                Math.max(...$.map(iconsContainerChildren, child => $(child).height())) > 0 ?
                    iconsContainer.height() :
                    parseInt(iconsContainer.css('max-height'))
                : 0;
        },
        getCellTimePaddingAdjustment(cellHeightPercent: number): string {
            let paddingStyle = "";
            switch (cellHeightPercent) {
                case 40:
                case 45:
                    paddingStyle = "padding-top:1px;font-size:0.6rem;";
                    break;
                case 50:
                case 55:
                    paddingStyle = "padding-top:3px;font-size:0.7rem;";
                    break;
                case 60:
                case 65:
                    paddingStyle = "padding-top:6px;";
                    break;
            }
            return paddingStyle;
        },
        getCellAppointmentTimePaddingAdjustment(cellHeightPercent) {
            let paddingStyle = "";
            switch (cellHeightPercent) {
                case "40":
                case "45":
                    paddingStyle = "0.2vh";
                    break;
                case "50":
                case "55":
                    paddingStyle = "0.4vh";
                    break;
                case "60":
                case "65":
                    paddingStyle = "0.6vh";
                    break;
                case "75":
                case "75":
                    paddingStyle = "0.8vh";
                    break;
                default:
                    break;
            }
            return paddingStyle;
        },
        getDragResizingFontAdjustment(columnWidthPercent){
            let style = "";
            switch (columnWidthPercent) {
                case "20":
                case "25":
                    style = "0.5rem";
                case "30":
                case "35":
                    style = "0.6rem";
                case "40":
                case "45":
                    style = "0.7rem";
            }
            return style;
        },
        getAppointmentColors(appointDetail) {
            function getServiceCategoryForeground(appointDetail) {
                if (!appointDetail.serviceCategoryBackgroundColorRgba) return '';
                const brightness = (
                    (appointDetail.serviceCategoryBackgroundColorRgba[0] * 299)
                    + (appointDetail.serviceCategoryBackgroundColorRgba[1] * 587)
                    + (appointDetail.serviceCategoryBackgroundColorRgba[2] * 114)
                ) / 1000;
                return brightness > 149 ? '' : 'white';
            }
            
            const colors = {
                serviceCategory: appointDetail.serviceCategoryBackgroundColorRgba ? `rgba(${
                    appointDetail.serviceCategoryBackgroundColorRgba[0]
                    }, ${appointDetail.serviceCategoryBackgroundColorRgba[1]}, ${
                    appointDetail.serviceCategoryBackgroundColorRgba[2]
                    }, ${appointDetail.serviceCategoryBackgroundColorRgba[3]});` : 'white',
                serviceCategoryForeground: getServiceCategoryForeground(appointDetail),
                appointmentCategoryBackground: appointDetail.appointmentCategoryBackgroundColorRgba ? `rgba(${
                    appointDetail.appointmentCategoryBackgroundColorRgba[0]
                    }, ${appointDetail.appointmentCategoryBackgroundColorRgba[1]}, ${
                    appointDetail.appointmentCategoryBackgroundColorRgba[2]
                    }, ${appointDetail.appointmentCategoryBackgroundColorRgba[3]});` : 'white',
                appointmentCategoryForeground: appointDetail.appointmentCategoryForegroundColorRgba ? `rgba(${
                    appointDetail.appointmentCategoryForegroundColorRgba[0]}, ${
                    appointDetail.appointmentCategoryForegroundColorRgba[1]
                    }, ${appointDetail.appointmentCategoryForegroundColorRgba[2]}, ${
                    appointDetail.appointmentCategoryForegroundColorRgba[3]
                    });` : '',
            };

            switch(globals.primaryAppointmentStyle) {
                case Meevo.Model.PrimaryAppointmentStyleSelectionEnum.UseServiceCategory:
                    return {
                        sideBarBackgroundColorStyle: `background-color: ${colors.appointmentCategoryBackground}`,
                        backgroundColorStyle: `background-color: ${colors.serviceCategory}`,
                        foregroundColorStyle: `color: ${colors.serviceCategoryForeground}`
                    }
                case Meevo.Model.PrimaryAppointmentStyleSelectionEnum.UseAppointmentCategory:
                default:
                    return {
                        sideBarBackgroundColorStyle: `background-color: ${colors.serviceCategory}`,
                        backgroundColorStyle: `background-color: ${colors.appointmentCategoryBackground}`,
                        foregroundColorStyle: `color: ${colors.appointmentCategoryForeground}`
                    }
            }
        }
    };

    $rootScope.$on("removeAppointmentOverlay", (event, args) => {
        service.removeOverlay(args.appointmentServiceIds);
    });

    return service;
}]);